import React from 'react';
import styled from 'styled-components';

// import { Button } from 'components'
import { FaListUl } from 'react-icons/fa'

const Container = styled.div`
    width: 100%;
    max-width: 80vw;
    min-height: 100vh;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    @media (min-width: 1200px) {
        max-width: 60vw;
    }
`

const Title = styled.div`
    font-weight: bolder;
    font-size: 3rem;
    word-wrap: break-word;
    margin-bottom: 0.5rem;
    text-align: center;
`

const Subtitle = styled.div`
    font-size: 1rem;
    text-align: center;
    margin-bottom: 1rem;
    max-width: 50vw;
    text-transform: uppercase;
    color: var(--secondary-accent-color);
    font-weight: bolder;
    @media (max-width: 600px) {
        max-width: 80vw;
    }
`

const Banner = styled.img`
    max-width: 80vw;
    width: 36rem;
    height: 20rem;
    border: 1px solid white;
    border-radius: 10px;
`

const Wrapper = styled.div`
    margin: 1rem 0;
    width: 100%;
    display: grid;
    justify-items: center;
    grid-template-columns: 49% 49%;
    grid-gap: 2%;
    grid-template-rows: 5rem;
`

const Button = styled.div`
    height: 5rem;
    width: 100%;
    max-width: 20rem;
    border-radius: 5px;
    cursor: pointer;
    background-color: ${props => props.selected ? 'var(--focus-color)' : 'var(--secondary-color)'};
    flex-grow: 4;
    justify-self: ${props => props.justifySelf};
    font-size: 1rem;
    font-weight: bolder;
    display: grid;
    grid-template-columns: 2rem 1fr;
    align-items: center;
    padding: 1rem;

    :hover {
        filter: brightness(var(--brightness));
    }
`

const FeaturesContainer = styled.div`
    margin-bottom: 1rem;
    display: grid;
    grid-template-columns: auto auto auto;
    grid-template-rows: auto auto;
    grid-gap: 1rem;
    @media (max-width: 1100px) {
        grid-template-columns: 50% 50%;
        grid-template-rows: auto auto auto;
    }

    @media (max-width: 800px) {
        grid-template-columns: 100%;
        grid-template-rows: auto auto auto auto auto auto;
    }
`

const Card = styled.div`
    width: 20rem;
    height: 25rem;
    display: flex;
    flex-direction: column;
    align-items: center;
`

const Image = styled.img`
    margin-top: 0.5rem;
    width: 100%;
    height: 100%;
    object-fit: contain;
    border: 1px solid white;
    border-radius: 10px;
`


const TaskTab = props => {
    const [view, setView] = React.useState('List')
    return (
        <Container>
            <Title>List/Kanban</Title>
            <Subtitle>Manage your tasks</Subtitle>
            <Banner/>
            <Wrapper>
                <Button selected={view === 'List'} onClick={() => setView('List')} justifySelf='end'>
                    <FaListUl/>
                    List
                </Button>
                <Button selected={view === 'Kanban'} onClick={() => setView('Kanban')} justifySelf='start'>
                    <FaListUl/>
                    Kanban
                </Button>
            </Wrapper>

            <Subtitle>Features</Subtitle>
            <FeaturesContainer>
                <Card>
                    Priority
                    <Image/>
                </Card>

                <Card>
                    Drag-drop
                    <Image/>
                </Card>
                
                <Card>
                    Notes
                    <Image/>
                </Card>

                <Card>
                    Tags
                    <Image/>
                </Card>

                <Card>
                    Schedule
                    <Image/>
                </Card>

                <Card>
                    Reminders
                    <Image/>
                </Card>
            </FeaturesContainer>
        </Container>
    )
}

export default TaskTab